import { render, staticRenderFns } from "./section7.vue?vue&type=template&id=b2b77aa4&scoped=true"
import script from "./section7.vue?vue&type=script&lang=js"
export * from "./section7.vue?vue&type=script&lang=js"
import style0 from "./section7.vue?vue&type=style&index=0&id=b2b77aa4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b77aa4",
  null
  
)

export default component.exports